<template>
  <div>
    <div class="chart-box">
      <div>
        <h5>Result</h5>
        <table>
          <tbody>
            <tr>
              <td>{{this.stats.result['abandoned']}}</td>
              <td>Abandoned</td>
            </tr>
            <tr>
              <td>{{this.stats.result['canceled']}}</td>
              <td>Canceled</td>
            </tr>
            <tr>
              <td>{{this.stats.result['draw']}}</td>
              <td>Draw</td>
            </tr>

            <tr class="line-break">
              <td colspan="2">---</td>
            </tr>
            <tr>
              <td><span class="info">{{this.stats.result['lost']}}</span></td>
              <td><span class="info">Lost</span></td>
            </tr>
            <tr>
              <td>{{this.stats.result.lost_by['dl']}}</td>
              <td>Lost by DL</td>
            </tr>
            <tr>
              <td>{{this.stats.result.lost_by['runs']}}</td>
              <td>Lost by Runs</td>
            </tr>
            <tr>
              <td>{{this.stats.result.lost_by['wickets']}}</td>
              <td>Lost by Wickets</td>
            </tr>

            <tr class="line-break">
              <td colspan="2">---</td>
            </tr>
            <tr>
              <td><span class="info">{{this.stats.result['won']}}</span></td>
              <td><span class="info">Won</span></td>
            </tr>
            <tr>
              <td>{{this.stats.result.won_by['dl']}}</td>
              <td>Won by DL</td>
            </tr>
            <tr>
              <td>{{this.stats.result.won_by['runs']}}</td>
              <td>Won by Runs</td>
            </tr>
            <tr>
              <td>{{this.stats.result.won_by['wickets']}}</td>
              <td>Won by Wickets</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h5>Batting</h5>
        <table>
          <tbody>
            <tr>
              <td>{{this.stats.bat.run['6s'] * 6}}</td>
              <td><span class="silent">runs from </span><span class="info">{{this.stats.bat.run['6s']}} sixes</span></td>
            </tr>
            <tr>
              <td>{{this.stats.bat.run['4s'] * 4}}</td>
              <td><span class="silent">runs from </span><span class="info">{{this.stats.bat.run['4s']}} fours</span></td>
            </tr>
            <tr>
              <td>{{this.stats.bat.run['total']}}</td>
              <td>Total Runs</td>
            </tr>
            <tr>
              <td>{{this.stats.bat['all_out']}}</td>
              <td>All out</td>
            </tr>
            <tr>
              <td>{{this.stats.bat['wickets']}}</td>
              <td>Dismissed</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h5>Bowl</h5>
        <table>
          <tbody>
            <tr>
              <td>{{this.stats.bowl.wickets}}</td>
              <td>Wickets</td>
            </tr>
            <tr>
              <td>{{this.stats.bowl.runs}}</td>
              <td>Runs</td>
            </tr>
            <tr>
              <td>{{this.stats.bowl.balls}}</td>
              <td>Balls</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import  RelativeMatch  from '@/components/cricket/RelativeMatch'

export default {
  components : {
    'RelativeMatch': RelativeMatch
  },
  props: {
    teamKey: String,
    stats: Object
  },

  data () {
    return {
    }
  },

  mounted () {
  }
}
</script>
